import React, { useState } from "react";
import images from "constants/images";

const BootstrapTable = (props) => {
  const { data, columns, isLoading } = props;
  
  return (
    <>
      <div>
        <div className="_tab_htLane"> 
          <div className="anv_fr_detailHead">
            <table className="_trpTable_xd" style={{minWidth:columns.length*140 }}>
              <thead className="table_head_style">
                <tr>
                  {columns?.map((column, index) => (
                    <th key={index}>{column?.header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? data?.map((row, rowIndex) => {

                  // Check if missing_quantity is not 0
                  const hasMissingQuantity =
                  row?.challan_items?.every(
                    (item) => item.missing_quantity == 0
                  );

            
                  return (
                  <tr key={rowIndex}  className={row?.challan_items?hasMissingQuantity ? "bg-green" : "bg-red":""}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>{row[column?.accessor]}</td>
                    ))}
                  </tr>
                )}) :
                  <tr>
                    <td><span className="_tblText">No data</span></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </>
  );
};

export default BootstrapTable